export function ownerPlan(subscription, now = Date.now()) {
  if (!subscription || !["active", "pending"].includes(subscription.status)) return "default";
  const start = subscription.currentPeriodStart == null ? null : +new Date(subscription.currentPeriodStart);
  const end = subscription.currentPeriodEnd == null ? null : +new Date(subscription.currentPeriodEnd);
  if (start != null && (!Number.isFinite(start) || start > now)) return "default";
  if (end != null && (!Number.isFinite(end) || end <= now || start != null && end <= start)) return "default";
  if (subscription.status === "pending" && (start == null || end == null)) return "default";
  const plan = String(subscription?.plan || "").toLowerCase();
  return ["plus", "pro"].includes(plan) ? plan : "default";
}

export function communityJoinPath(slug, upgrade = false) {
  return `/join/group/${encodeURIComponent(slug)}${upgrade ? "?upgrade=1" : ""}`;
}

export function managesCommunity(group, userId) {
  if (!userId) return false;
  return String(group?.creatorId?._id || group?.creatorId) === String(userId)
    || Boolean(group?.members?.some(member => String(member.userId?._id || member.userId) === String(userId)
      && ["owner", "admin"].includes(member.role)));
}

export function lessonAccess(lesson) {
  return lesson.access === "free" ? "free" : "premium";
}

export function lessonLocked(lesson, group, userId) {
  // The server supplies locked after checking the member's current payment.
  return !managesCommunity(group, userId) && lesson.locked === true;
}

export function publicPlans(plans) {
  return plans.filter(plan => ["default", "plus", "pro"].includes(plan.id));
}
